import React from 'react';

interface DashboardMetricCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
  variant?: 'default' | 'success' | 'warning' | 'danger';
  onClick?: () => void;
}

const DashboardMetricCard: React.FC<DashboardMetricCardProps> = ({
  title,
  value,
  subtitle,
  variant = 'default',
  onClick
}) => {
  const variantClasses = {
    default: 'border-white/40 dark:border-gray-700/40 bg-white/70 dark:bg-gray-800/70 backdrop-blur-lg shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] dark:shadow-[0_8px_32px_0_rgba(0,0,0,0.4)]',
    success: 'border-green-400/40 dark:border-green-600/40 bg-gradient-to-br from-green-50/80 to-emerald-50/80 dark:from-green-900/30 dark:to-emerald-900/30 backdrop-blur-lg shadow-[0_8px_32px_0_rgba(34,197,94,0.2)] dark:shadow-[0_8px_32px_0_rgba(0,0,0,0.4)]',
    warning: 'border-amber-400/40 dark:border-amber-600/40 bg-gradient-to-br from-amber-50/80 to-orange-50/80 dark:from-amber-900/30 dark:to-orange-900/30 backdrop-blur-lg shadow-[0_8px_32px_0_rgba(245,158,11,0.2)] dark:shadow-[0_8px_32px_0_rgba(0,0,0,0.4)]',
    danger: 'border-red-400/40 dark:border-red-600/40 bg-gradient-to-br from-red-50/80 to-rose-50/80 dark:from-red-900/30 dark:to-rose-900/30 backdrop-blur-lg shadow-[0_8px_32px_0_rgba(239,68,68,0.2)] dark:shadow-[0_8px_32px_0_rgba(0,0,0,0.4)]'
  };

  const textColorClasses = {
    default: 'text-gray-900 dark:text-gray-100',
    success: 'text-green-900 dark:text-green-100',
    warning: 'text-amber-900 dark:text-amber-100',
    danger: 'text-red-900 dark:text-red-100'
  };

  const cursorClass = onClick ? 'cursor-pointer hover:shadow-[0_8px_32px_0_rgba(31,38,135,0.25)] hover:-translate-y-1 transition-all duration-300' : 'transition-all duration-300 hover:shadow-[0_8px_32px_0_rgba(31,38,135,0.2)]';

  return (
    <div
      className={`border-2 rounded-2xl p-6 ${variantClasses[variant]} ${cursorClass}`}
      onClick={onClick}
    >
      <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-2">{title}</h3>
      <div className={`text-5xl font-bold ${textColorClasses[variant]} mb-1 tracking-tight`}>
        {value}
      </div>
      {subtitle && (
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 font-medium">{subtitle}</p>
      )}
    </div>
  );
};

export default DashboardMetricCard;
